/* Actions */
import { ACTION_TYPES_BASE_NAME } from "./actions";

/* Reducers */
import asset from "./asset/reducers";
import continueWatching from "./continueWatching/reducers";
import seasons from "./seasons/reducers";

/* Others */
import { makeFetchReducers, FETCH_REDUCERS_KEYS } from "../../utils";

const reducers = makeFetchReducers(ACTION_TYPES_BASE_NAME, null, {
  reducersToCombine: {
    asset,
    continueWatching,
    seasons
  },
  whitelistedKeys: [FETCH_REDUCERS_KEYS.STATUS]
});

export default reducers;
